import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  AdministratorList,
  UpdateAdministratorListDTO,
} from "src/app/_models/Administrator";
import { UpdateStatusDto } from "src/app/_models/UpdateStatusDto";
import { AdministratorListActionTypes } from "src/app/constants/StoreConstants";

export const ResetAdministratorState = createAction(
  AdministratorListActionTypes.ResetAdministratorState
);

export const GetAdministratorListTable = createAction(
  AdministratorListActionTypes.GetAdministratorListTable,
  props<{ pageNumber: number; isInitialLoad: boolean }>()
);

export const GetAdministratorListTableSuccess = createAction(
  AdministratorListActionTypes.GetAdministratorListTableSuccess,
  props<{ result: AdministratorList[] }>()
);

export const GetAdministratorListTableError = createAction(
  AdministratorListActionTypes.GetAdministratorListTableError,
  props<{ administratorTableError: HttpErrorResponse }>()
);

export const GetAdministratorTableLength = createAction(
  AdministratorListActionTypes.GetAdministratorTableLength
);

export const GetAdministratorTableLengthSuccess = createAction(
  AdministratorListActionTypes.GetAdministratorTableLengthSuccess,
  props<{ length: number }>()
);

export const GetAdministratorTableLengthError = createAction(
  AdministratorListActionTypes.GetAdministratorTableLengthError,
  props<{ error: HttpErrorResponse }>()
);

export const UpdateAdministratorTable = createAction(
  AdministratorListActionTypes.UpdateAdministratorTable,
  props<{ params: UpdateAdministratorListDTO }>()
);

export const UpdateAdministratorTableError = createAction(
  AdministratorListActionTypes.UpdateAdministratorTableError,
  props<{ error: HttpErrorResponse }>()
);
export const ResetAdministratorTable = createAction(
  AdministratorListActionTypes.ResetAdministratorTable,
  props<{ isInitialLoad: boolean }>()
);

export const ResetAdministratorTableSuccess = createAction(
  AdministratorListActionTypes.ResetAdministratorTableSuccess,
  props<{ isInitialLoad: boolean }>()
);

export const ResetAdministratorTableError = createAction(
  AdministratorListActionTypes.ResetAdministratorTableError,
  props<{ error: HttpErrorResponse }>()
);

export const DeleteAdministrators = createAction(
  AdministratorListActionTypes.DeleteAdministrators,
  props<{ userIdList: number[] }>()
);

export const DeleteAdministratorsSuccess = createAction(
  AdministratorListActionTypes.DeleteAdministratorsSuccess
);

export const DeleteAdministratorsError = createAction(
  AdministratorListActionTypes.DeleteAdministratorsError,
  props<{ error: any }>()
);

export const ResetAdministratorCrudProperties = createAction(
  AdministratorListActionTypes.ResetAdministratorCrudProperties
);

export const UpdateAdminAccountStatus = createAction(
  AdministratorListActionTypes.UpdateAdminAccountStatus,
  props<{ param: UpdateStatusDto[] }>()
);

export const UpdateAdminAccountStatusSuccess = createAction(
  AdministratorListActionTypes.UpdateAdminAccountStatusSuccess,
  props<{ isAdminAccountStatusUpdateSuccessful: boolean }>()
);

export const UpdateAdminAccountStatusError = createAction(
  AdministratorListActionTypes.UpdateAdminAccountStatusError,
  props<{ error: any }>()
);

export const ResetUpdateAdminAccountStatusProps = createAction(
  AdministratorListActionTypes.ResetUpdateAdminAccountStatusProps
)